import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

// Variant for locale options.
const localeOptions = definePartsStyle({
  container: {},
  button: {
    fontSize: `sm`,
    fontWeight: `900`,
    textTransform: `uppercase`,
    bg: `transparent`,
    _expanded: {
      bg: `colours.colour-4`
    },
    svg: {
      color: `colours.colour-7`
    }
  },
  panel: {
    bg: `colours.colour-5`
  }
});

export const accordionTheme = defineMultiStyleConfig({
  variants: { localeOptions }
});
